<template>
	<div
		style="margin: 10px;">
      <v-dialog
        v-model="Deletedialog"
        max-width="290">
        <v-card>
          <v-card-title class="headline">Message:</v-card-title>

          <v-card-text>
            Are you sure you want to delete this person from the family history.
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="green darken-1"
              text
              @click="Deletedialog = false">
              Cancel
            </v-btn>

            <v-btn
              color="green darken-1"
              text
              @click="deletePerson(); save()">
              Yes
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-flex
        xs10
        offset-xs1>

				<div
					v-if="$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 's'">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details></v-text-field>

					<br/>

          <v-btn
            color="primary"
            dark
            class="mb-2"
            @click="addPerson">Add Family Member</v-btn>
				</div>
        <v-toolbar
					v-else
          flat
          color="white">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details></v-text-field>

          <v-spacer></v-spacer>

          <v-btn
            color="primary"
            dark
            class="mb-2"
            @click="addPerson">Add Family Member</v-btn>
        </v-toolbar>

        <v-data-table
          :headers="headers"
          :items="user.familyHistory"
          item-key="pid"
          :search="search">
          <template
            v-slot:items="props">
            <tr @click="props.expanded = !props.expanded">
              <td>
                <v-icon>expand_more</v-icon>{{ god }}
              </td>

              <td class="text-xs-right">{{ props.item.relationship }}</td>

              <td class="text-xs-right">{{ props.item.age }}</td>
            </tr>
          </template>

          <template v-slot:item.action="{ item }">
            <v-icon
              v-show='item.relationship!=="self"'
              small
              @click.stop="editPerson(item)"
              class='mr-2'
              title='edit'>
              edit
            </v-icon>

            <v-icon
              title='delete'
              v-if='!imediates.includes(item.relationship)'
              small
              @click.stop="currentPerson = item,Deletedialog = true">
              delete
            </v-icon>
          </template>

          <template v-slot:expand="props">
            <v-card
              class="mx-auto"
              raised
              hover>
              <v-card-text>
                <h3 class="headline mb-2">
                  {{ props.item.name }}
                </h3>

                <div class="mb-2">Relationship to patient: {{ props.item.relationship }}</div>

                <div class="mb-2">Age: {{ props.item.age }}</div>

                <div class="mb-2">Gender: {{ props.item.gender }}</div>

                <div class="mb-2">Living: {{ props.item.isLiving }}</div>

                <div class="mb-2">Notes: {{ props.item.notes }}</div>
              </v-card-text>
            </v-card>
          </template>
        </v-data-table>
      </v-flex>

      <v-dialog
        v-model="personModal"
        persistent
        scrollable
        width="500">
        <personDetailForm
          :data='user.familyHistory'
          :indexNum='personIndex'
          v-on:closePersonModal="personModal = false; save()"/>
      </v-dialog>

      <v-dialog
        v-model="newPersonModal"
        persistent
        scrollable
        width="500">
        <NewMember
          :key="personKey"
          :data="user.familyHistory"
          v-on:closeNewPersonModal="newPersonModal = false; save()"
          v-on:cancelNewPersonModal="newPersonModal = false;"/>
      </v-dialog>
	</div>
</template>

<script>
  import { mapFields } from 'vuex-map-fields';
  import PersonDetailForm from '../components/questionnaire/PatientFormComp/PersonDetailForm'
  import NewMember from '../components/questionnaire/PatientFormComp/NewMember'
  import Pdf from '../components/questionnaire/Pdf'
  import { editFamilyHistory, getUserData } from '../helper/firestore'
  export default {
    components: {
      PersonDetailForm,
      NewMember,
      Pdf
    },
    data () {
      return {
        personKey: 0,
        currentPerson: null,
        Deletedialog: false,
        saveme: false,
        personModal: false,
        newPersonModal: false,
        personIndex: null,
        tableSettings: { rowsPerPage: -1 },
        search: '',
        imediates: [
          "self",
          "mother",
          "father",
          "maternal grandfather",
          "maternal grandmother",
          "paternal grandfather",
          "paternal grandmother",
        ],
        headers: [
          { text: 'Name', align: 'left', value: 'name' },
          { text: 'Relationship', align: 'right', value: 'relationship' },
          { text: 'Actions', align: 'right', value: 'action', sortable: false }
        ],
        items: [
          {
            text: 'Home',
            disabled: false,
            to: '/home'
          },
          {
            text: 'Family History',
            disabled: true,
          }
        ],
      }
    },
    methods: {
      save() {
        this.dataModel = this.user.familyHistory
        editFamilyHistory(this.user.familyHistory, (data) => {
          if (data.status === 200) {
            this.snackBarType = "success"
            this.snackBarshow = true
            this.snackBarmessage = "Update complete"
          } else {
            this.snackBarType = "warning"
            this.snackBarshow = true;
            this.snackBarmessage = "Update failed";
          }
          this.saveme = false
        })
      },
      addPerson() {
        this.personKey++;
        this.saveme = true;
        this.newPersonModal = true;
      },
      deletePerson () {
        this.saveme = true;
        this.personIndex = this.user.familyHistory.findIndex(person => person.pid === this.currentPerson.pid);
        this.user.familyHistory.splice(this.personIndex, 1);
        this.Deletedialog = false;
      },
      editPerson (data) {
        this.saveme = true;
        this.personIndex = this.user.familyHistory.findIndex(person => person.pid === data.pid);
        this.personModal = true;
      },
      genID () {
        var ALPHABET =
          "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";

        var ID_LENGTH = 8;

        var generate = function () {
          var rtn = "";
          for (var i = 0; i < ID_LENGTH; i++) {
            rtn += ALPHABET.charAt(Math.floor(Math.random() * ALPHABET.length));
          }
          return rtn;
        };
        return generate();
      },
    },
    computed: {
      ...mapFields([
        'isAuthorized',
        'user',
        'snackBarshow',
        'snackBarType',
        'snackBarmessage',
      ]),
      ...mapFields("patientQuestion", [
        "dataModel",
        "snackbar",
        "errorText",
        "genderList",
        "formID"
      ]),
    },
  }
</script>


<style scoped>
.tile {
  width: 100%;
  height: 300px;
  background-color: #11caf8;
  background-size: contain;
  display: inline-block;
  cursor: pointer;
  transition: all 0.4s ease-out;
  box-shadow: 0px 35px 77px -17px rgba(0, 0, 0, 0.44);
  overflow: hidden;
  color: white;
  font-family: "Roboto";
}
.tile img {
  width: 100%;
  height: auto;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  transition: all 0.4s ease-out;
}
.tile .text {
  /*   z-index:99; */
  position: absolute;
  padding: 30px;
  height: calc(100% - 60px);
}
.tile h1 {
  font-weight: 300;
  margin: 0;
  text-shadow: 2px 2px 10px rgba(0, 0, 0, 0.8);
}

.animate-text {
  opacity: 0;
  transition: all 0.6s ease-in-out;
}
.tile:hover {
  /*   background-color:#99aeff; */
  box-shadow: 0px 35px 77px -17px rgba(0, 0, 0, 0.64);
  transform: scale(1.05);
}
.tile:hover img {
  opacity: 0.2;
}
.tile:hover .animate-text {
  transform: translateX(0);
  opacity: 1;
}
.dots {
  position: absolute;
  bottom: 20px;
  right: 30px;
  margin: 0 auto;
  width: 30px;
  height: 30px;
  color: currentColor;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}

.dots span {
  width: 5px;
  height: 5px;
  background-color: currentColor;
  border-radius: 50%;
  display: block;
  opacity: 0;
  transition: transform 0.4s ease-out, opacity 0.5s ease;
  transform: translateY(30px);
}

.tile:hover span {
  opacity: 1;
  transform: translateY(0px);
}

.dots span:nth-child(1) {
  transition-delay: 0.05s;
}
.dots span:nth-child(2) {
  transition-delay: 0.1s;
}
.dots span:nth-child(3) {
  transition-delay: 0.15s;
}

@media (max-width: 1000px) {
  .wrap {
    flex-direction: column;
    width: 400px;
  }
}
</style>
